import { render, staticRenderFns } from "./materialScience_delete.vue?vue&type=template&id=e8db5a2e&scoped=true"
import script from "./materialScience_delete.vue?vue&type=script&lang=js"
export * from "./materialScience_delete.vue?vue&type=script&lang=js"
import style0 from "./materialScience_delete.vue?vue&type=style&index=0&id=e8db5a2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8db5a2e",
  null
  
)

export default component.exports